var $ = require('jquery');

$(function () {
    $('.datepicker').datepicker();
});

$(function () {
    var formButton,
        submitText,
        loader;

    formButton = $(".form__body__submit");
    submitText = formButton.find('.submit-text');
    loader = formButton.find('.loader');

    var uniqueSubmitId = '';
    var formElement = this.querySelector("form");
    var loadFileUpload = false;

    if (formElement) {
        var uniqueSubmitIdElement = formElement.querySelector("input[name='uniquesubmitid']");

        if (uniqueSubmitIdElement && uniqueSubmitIdElement.value) {
            uniqueSubmitId = uniqueSubmitIdElement.value;
            loadFileUpload = true;
        }
    }

    var isValid = true;
    var isProcessing = false;
    $(".form__body__submit")
        .on("click",
            function (e) {
                e.preventDefault();

                //disable clicks while already submitting
                if (isProcessing)
                    return;

                isProcessing = true;

                if (submitText && loader) {
                    formButton.addClass('isLoading');
                }

                isValid = true;
                var formNode = $(this).closest("form");
                var formId = formNode.attr("id");
                var contextLang = formNode.attr("data-contextLang");
                var payload = [];
                if ($('.mtcaptcha[data-formid="' + formId + '"]').length) {
                    let checkCaptcha = new Promise((resolve, reject) => {
                        let mtcaptchaToken = mtcaptcha.getVerifiedToken();
                        if (mtcaptchaToken.length === 0) {
                            reject(false);

                            isProcessing = false;
                            if (submitText && loader) {
                                formButton.removeClass('isLoading');
                            }
                        } else {
                            $.ajax(
                                {
                                    url: "/api/Sitecore/MTCaptchaValidation/MTCaptchaValidation",
                                    type: "POST",
                                    context: this,
                                    data: { token: mtcaptchaToken },
                                    success: function (data) {
                                        resolve(data);
                                    },
                                    error: function (data) {
                                        reject(false);
                                    }
                                }
                            );
                        }
                    });
                    //first check captcha, then check the rest
                    checkCaptcha.then(function () {
                        parseForm(payload, formNode, formId, contextLang, loadFileUpload);
                    })
                        .catch((rejection) => {
                            checkInvalid($('.mtcaptcha[data-formid="' + formId + '"]'), true, true);
                            formNode.find("[data-isInvalid='true']")
                                .each(function () {
                                    $(this).next('.form__field--error').show().parent().addClass('form__field--has-error');
                                });
                        });
                } else {
                    parseForm(payload, formNode, formId, contextLang, loadFileUpload);
                }
            });

    function checkInvalid(domElement, isRequired, secondaryValidator, errorSelector) {
        if (isRequired && secondaryValidator) {
            isValid = false;
            $(domElement).attr('data-isInvalid', 'true');
            if (!!errorSelector) {
                if ($(domElement).attr('data-is-invalid-selector')) {
                    $(domElement).attr('data-is-invalid-selector', $(domElement).attr('data-is-invalid-selector') + ',' + errorSelector);
                } else {
                    $(domElement).attr('data-is-invalid-selector', errorSelector);
                }
            }
        }
    }

    function parseForm(payload, formNode, formId, contextLang, loadFileUpload) {
        var contactQs,
            referencePage;
        contactQs = $.QueryString["contact"];
        if (contactQs) {
            var contact = {};
            contact["contact"] = contactQs;
            payload.push(contact);
        }

        referencePage = $.QueryString["referencePage"];
        if (referencePage) {
            payload.push({ label: "Reference Page Url", value: referencePage });
        }

        formNode.find("[data-formId = '" + formId + "']")
            .each(function () {
                $(this).attr('data-isInvalid', 'false');
                $(this).siblings('.form__field--error').hide();
                var currentItem = {};
                currentItem["label"] = $("label[for='" + $(this).attr('id') + "']").text();
                currentItem["isEmail"] = false;
                //if its a multi checkbox we need to make an array of checkboxes for each value
                if ($(this).hasClass("multi-checkbox__checkboxes__container")) {
                    currentItem["label"] = $(this).find("label").first().text();

                    var multiCheckboxPayload = [];
                    var anyChecked = false;
                    $(this)
                        .find("input[type='checkbox']")
                        .each(function () {
                            var checkbox = {};
                            checkbox["label"] = $("label[for='" + $(this).attr('id') + "']").text();
                            var isChecked = $(this).is(":checked");
                            checkbox["value"] = isChecked;
                            if (!anyChecked && isChecked) {
                                anyChecked = isChecked;
                            }
                            multiCheckboxPayload.push(checkbox);
                        });
                    checkInvalid(this, $(this).data('required'), !anyChecked);

                    currentItem["multivalue"] = multiCheckboxPayload;
                }
                else if ($(this).is("select")) {
                    var selectedValue = $(this).find(":selected").val();
                    checkInvalid(this, $(this).data('required'), selectedValue === "_default");
                    currentItem["value"] = escapeHtml(selectedValue);
                }
                //if its a checkbox we just need to know if its checked
                else if ($(this).is(':checkbox')) {
                    var isChecked = $(this).is(":checked");
                    checkInvalid(this, $(this).data('required'), !isChecked);

                    currentItem["value"] = isChecked;
                }
                // if its a div then its captcha, ignore
                else if ($(this).is('div')) {
                    return true;
                }
                else {
                    var textValue = $(this).val();
                    var isRequired = $(this).data('required');
                    if ($(this).attr('type') === 'email' && isRequired) {
                        currentItem["isEmail"] = true;
                        checkInvalid(this, true, textValue.length === 0 || !isEmail(textValue));
                    }
                    else if ($(this).attr('type') === 'email' && textValue.length !== 0) {
                        currentItem["isEmail"] = true;
                        checkInvalid(this, true, !isEmail(textValue));
                    }
                    else {
                        checkInvalid(this, $(this).data('required'), textValue.length === 0, '[data-required-error]');
                        checkInvalid(this, $(this).data('regex'), !new RegExp($(this).data('regex')).test(textValue), '[data-regex-error]');
                        checkInvalid(this, $(this).data('maxChars'), textValue.length > $(this).data('maxChars'), '[data-max-chars-error]');
                    }

                    currentItem["value"] = textValue === '$date' ? '$date:' + new Date() : textValue;
                }
                payload.push(currentItem);
            });

        // Captcha Submit tracking
        if (typeof (dataLayer) != 'undefined' && dataLayer != null) {
            var mtCaptchaIsVisible = null;
            var mtCaptchaIsVerified = null;

            if (typeof (mtcaptcha) != 'undefined' && mtcaptcha != null && mtcaptcha.getStatus() != null) {
                mtCaptchaIsVisible = mtcaptcha.getStatus().isVisible;
                mtCaptchaIsVerified = mtcaptcha.getStatus().isVerified;
            }

            dataLayer.push({ 'event': 'wcmsFormSubmit', 'formIsValid': isValid, 'mtcaptchaIsVerified': mtCaptchaIsVerified, 'mtcaptchaIsVisible': mtCaptchaIsVisible });
        }

        if (!isValid) {
            formNode.find("[data-isInvalid='true']")
                .each(function () {
                    var $this,
                        invalidSelector;

                    $this = $(this);
                    invalidSelector = $this.attr('data-is-invalid-selector');

                    if (!!invalidSelector) {
                        $this.siblings(invalidSelector).show().parent().addClass('form__field--has-error');
                    } else {
                        $(this).closest('.form__field').addClass('form__field--has-error').find('.form__field--error').show();
                    }

                    $this.attr('data-is-invalid-selector', '');
                });
            formNode.find("[data-isInvalid='false']").each(function () {
                $(this).closest('.form__field').removeClass('form__field--has-error').find('.form__field--error').hide();
            });

            isProcessing = false;
            if (submitText && loader) {
                formButton.removeClass('isLoading');
            }
        } else {
            var dataParams = {};

            if (loadFileUpload) {
                dataParams.data = { payload: JSON.stringify(payload), formId: formId, language: contextLang, uniqueSubmitId: uniqueSubmitId };
            } else {
                dataParams.data = { payload: JSON.stringify(payload), formId: formId, language: contextLang };
            }

            $.ajax({
                url: "/api/Sitecore/Form/HandleForm",
                type: "POST",
                context: this,
                data: dataParams.data,

                success: function (data) {
                    if (data) {
                        if (data.upload != null && data.upload.length > 0) {
                            var confirmation = null;
                            if (formNode.parent().hasClass("_501-form__form")) {
                                formNode.parents('._501-form__wrapper').children('._501-form__text').hide();
                                formNode.parents('._501-form__wrapper').children('._501-form__form').hide();
                                confirmation = document.querySelector("._501-form__confirmation[data-formId = '" + formId + "']");
                            } else {
                                formNode.hide();
                                confirmation = document.querySelector(".custom-form-confirmation");
                            }

                            if (confirmation) {
                                createUploadIframe(confirmation, data.upload);
                            }
                        }
                        else if (data.url != null && data.url.length > 0) {
                            window.location.href = data.url;
                        } else {
                            var confirmation = null;
                            if (formNode.parent().hasClass("_501-form__form")) {
                                formNode.parents('._501-form__wrapper').children('._501-form__text').hide();
                                formNode.parents('._501-form__wrapper').children('._501-form__form').hide();
                                confirmation = $("._501-form__confirmation[data-formId = '" + formId + "']");
                            } else {
                                formNode.hide();
                                confirmation = $(".custom-form-confirmation[data-formId = '" + formId + "']");
                            }
                            confirmation.show();
                            confirmation[0].scrollIntoView();
                        }

                        isProcessing = false;
                        if (submitText && loader) {
                            formButton.removeClass('isLoading');
                        }
                    } else {
                        handleError(payload);
                    }
                },
                error: handleError(payload)
            });
        }
    }
    function handleError(payload) {
        $.ajax({
            url: "/api/Sitecore/Form/HandleError",
            type: "POST",
            context: this,
            data: { payload: JSON.stringify(payload) }
        });
    }
    function isEmail(email) {
        var regex =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
    }
    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };

    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function (s) {
            return entityMap[s];
        });
    }

    function createUploadIframe(confirmation, url) {
        const confirmationBody = confirmation.querySelector(".custom-form-confirmation__body");
        if (confirmationBody) {
            window.GenericUtilities.createFileUploadIframe(confirmationBody, url);
            confirmation.setAttribute('style', '');
        }
    }

    $('form').keyup(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
        }
    });
});